'use client';

import { useMemo } from 'react';
import { PushToCRMGroup, MedRMStatus } from 'src/components';
import { useGetMappingsQuery } from 'src/api/redux';

const CrmCell = ({ row }) => {
  const { data: allMappings } = useGetMappingsQuery({
    sort: 'label',
    order: 'asc',
    page: 0,
    pageSize: 100,
  });

  const crmTypes = useMemo(() => {
    return Array.from(
      new Set(
        allMappings?.results
          ?.filter((mapping) => mapping.enabled)
          .map((mapping) => mapping.crm?.toLowerCase())
      )
    );
  }, [allMappings]);

  // Normalize provider object for education table (and other tables with nested provider data)
  // In education table: { id, institution, provider: { id, name, crm_links, ... } }
  // In other tables: { id, name, crm_links, ... }
  const provider = row?.provider || row;

  // This needs to be passed into pushToCRMGroup to define the content type of the row
  // because tables sometimes display content types that don't match the content type of the profile
  const entityType = provider?.type || provider?.content_type;

  const isMedRM = useMemo(() => crmTypes.includes('medrm'), [crmTypes]);

  return (
    <div
      id={`crm-cell-${provider.provider_id}`}
      onClick={(e) => e.stopPropagation()}
      className="h-full w-full flex items-center justify-start overflow-hidden"
    >
      {isMedRM ? (
        <MedRMStatus provider={provider} />
      ) : (
        <PushToCRMGroup
          provider={provider}
          variant="regular"
          entityType={entityType}
        />
      )}
    </div>
  );
};

export default CrmCell;
